// extracted by mini-css-extract-plugin
export default {"main":"Homepage_main__DO2b0"};